const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import ShowallContestGrid from './contestants/ShowallContestGrid.jsx';
import Title from './contestants/Title.jsx';
import ShowallNavigation from './contestants/ShowallNavigation.jsx';

//Action to save and fetch data
import { fetchFrontSetting, frontimmute, insertPayment, updateFrontData, stripePayment, couponApply } from '../actions/front_actions';

//Import Designs
import { Container, Backdrop, CircularProgress } from '@mui/material';


class Showallcontestants extends Component {

    constructor(props) {
        super(props);
        this.state = { language: "en", listgrid: "grid", wait: 1, form_val: null, short: this.props.shortagrument, search_text: '' };
    }

    componentDidMount = () => {
        this.setState({ wait: 1 })
        this.props.fetchFrontSetting(this.props.SITE_URL);
        setTimeout(function () {
            this.setState({ wait: 0 });
        }.bind(this), 1000);
    }

    handleCategoryChange = externalId => (event) => {
        this.props.frontimmute(event.target.name, event.target.value);
    }

    handleSortChange = externalId => (event) => {
        this.props.frontimmute(event.target.name, event.target.value);
    }

    handleSearchChange = externalId => (event) => {
        let values = event.target.value;
        if (values == '') {
            this.props.frontimmute('search_text', values);
        }
        this.setState({ search_text: values })
    }

    handleSearchClick = externalId => (event) => {
        this.props.frontimmute('search_text', this.state.search_text);
    }

    render() {
        const { t, i18n } = this.props;
        const shortatts = this.props.shortagrument;
        const values = this.props.model;

        if ((values) && (this.state.wait != 1)) {
            const color = this.props.model.settings.color;
            return (
                <Container className="wpvc_showcontestant_container">
                    {this.props.shortagrument.title != null &&
                        <Title
                            short={shortatts}
                        />
                    }

                    <ShowallNavigation
                        {...values}
                        {...color}
                        short={shortatts}
                        values={values}
                        searchtext={this.state.search_text}
                        catchange={this.handleCategoryChange}
                        sortchange={this.handleSortChange}
                        searchchange={this.handleSearchChange}
                        searchclick={this.handleSearchClick}
                    />

                    <ShowallContestGrid {...values}
                        view={this.state.listgrid}
                        short={shortatts}
                        SITE_URL={this.props.SITE_URL}
                        CONSTANT={this.props.CONSTANT}
                    />

                </Container>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }
    }
}

const settingstate = state => {
    return { model: state.wpvcfrontdata };
}

export default connect(settingstate, { frontimmute, fetchFrontSetting, updateFrontData, insertPayment, stripePayment, couponApply })(withTranslation("translations")(Showallcontestants));